import { render, staticRenderFns } from "./AddMetaDataComponent.vue?vue&type=template&id=f577daa4&"
import script from "./AddMetaDataComponent.vue?vue&type=script&lang=js&"
export * from "./AddMetaDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports